<template>
  <div class="volumes">
    <i class="fa fa-edit"
       @click="dialogObject = true"
    />
    <el-dialog
      width="400px"
      :title="`Добавление перечня ${tra[type]}`" :visible.sync="dialogObject">
      <div class="volumes">

        <div class="jobs-ul" v-if="!isSelect">
          <el-button size="small" class="add" type="primary" style="width: 100%; margin-bottom: 10px"
                     @click="isSelect = !isSelect">
            + Выбрать {{ tr[type] }}
          </el-button>
          <div style="display: flex; justify-content: flex-start">
          </div>
          <div
            class="jobs-li pick flex space-between" v-for="(job, index) in result" :key="index"
          >
            <div>
              <div class="flex" style="justify-content: flex-start">
                <div style="width: 24px">
                <Volumes
                  :plan="job.value"
                  :table="job.volumes || []"
                  :jobName="job.name"
                  :type="tra[type]"

                  @save="(s) => saveJobResult(s, index)"/>
                </div>
                <span style="margin-left: 16px">{{ job.name }}</span>
              </div>
            </div>

            <div class="flex align">
              <div>
                <div style="line-height: 22px">
                  <strong>Eд.</strong>
                </div>
                <el-input v-model.number="job.value" style="width: 80px"/>
              </div>
              <i class="el-icon-close" style="margin-left: 10px" @click="remove(index)"/>
            </div>
          </div>

          <strong>Итого: {{ total }}</strong>
        </div>

        <div class="jobs-ul" v-else>
          <div
            class="jobs-li" v-for="(job, index) in list" :key="index" @click="add(job)"
          >
            <span>{{ job.name }}</span>
          </div>

          <el-button size="small" class="add" style="width: 100%; margin: 20px 0 0 0" @click="isSelect = !isSelect">
            Назад
          </el-button>
        </div>
      </div>
      <div class="create-footer">
        <el-button @click="dialogObject = false">Закрыть</el-button>
        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import firebase from "firebase";
import Volumes from "./Volumes";
import VolumeMultiple from "./VolumeMultiple";
import {getCurrentMonth} from "../../../../utils/date";

export default {
  name: "AddProfTech",
  components: {VolumeMultiple, Volumes},
  props: {
    jobName: "",
    table: [Object, Array],
    type: String,
  },
  data() {
    return {
      dialogObject: false,
      isSelect: false,
      result: [],
      list: [],
      tr: {
        PROF: 'профессию',
        TECH: 'технику',
      },
      tra: {
        PROF: 'профессий',
        TECH: 'техники',
      },
    }
  },
  watch: {
    table: {
      deep: true,
      immediate: true,
      handler(table) {
        this.result = [
          ...table
        ]
      }
    }
  },
  methods: {
    add(job) {
      this.result.push(job);
      this.isSelect = false;
    },
    setVolumes(d, index) {
      this.result[index] = d
      this.result = [...this.result]
    },
    save() {
      this.$emit('save', {
        table: this.result,
        total: this.total
      })

      this.dialogObject = false;
    },
    saveJobResult(job, index) {
      this.result[index] = {
        ...this.result[index],
        value: job.total,
        volumes: job.table
      }
      this.result = [...this.result]
    },
    remove(index) {
      const result = [...this.result];
      result.splice(index, 1)
      this.result = [...result];
    }
  },
  mounted() {
    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).collection('jobs')
      .where('type', '==', this.type).get()
      .then((data) => {
        const result = []
        data.forEach((subDoc) => {
          const data = subDoc.data()
          result.push({
            name: data.name,
            value: data.value,
            volumes: data.volumes,
            id: subDoc.id,
          })
        })

        this.list = result;
      });
  },
  computed: {
    total() {
      let result = 0;

      this.result.forEach(({value}) => {
        result += value || 0
      })

      return result
    },
    currentMonth() {
      return getCurrentMonth(this.$route.query.name)
    }
  }
}
</script>

<style scoped lang="scss">
.volumes {
  max-width: 95%;
  margin: 0 auto;
}

.create-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
}

.jobs-li {
  justify-content: flex-start;
  min-height: 36px;
  padding: 8px 10px;
  display: flex;
  text-align: left;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);

  &.pick {
    height: 72px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    align-items: center;
  }

  &:hover {
    background: #eee;
  }

  &:last-child {
    border-bottom: none;
  }
}
</style>
<style lang="scss">
.volumes .el-dialog {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/components/AddProfTech.vue